function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.92764 11.3673H1.4819C1.20923 11.3673 0.98794 11.146 0.98794 10.8734V1.98192C0.98794 1.70925 1.20925 1.48796 1.4819 1.48796H5.92764C6.2008 1.48796 6.4216 1.26717 6.4216 0.994005C6.4216 0.720843 6.2008 0.5 5.92764 0.5H1.4819C0.664876 0.5 0 1.1649 0 1.98192V10.8734C0 11.6904 0.664876 12.3553 1.4819 12.3553H5.92764C6.2008 12.3553 6.4216 12.1345 6.4216 11.8613C6.4216 11.5881 6.2008 11.3673 5.92764 11.3673Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.7475 6.076L8.74414 3.11218C8.5505 2.92052 8.23734 2.923 8.04567 3.11713C7.85401 3.31126 7.85598 3.62394 8.05062 3.8156L10.1969 5.93373H4.44562C4.17246 5.93373 3.95166 6.15453 3.95166 6.42769C3.95166 6.70085 4.17246 6.92167 4.44562 6.92167H10.1969L8.05062 9.0398C7.85601 9.23147 7.85452 9.54414 8.04567 9.73827C8.14248 9.83608 8.26993 9.88547 8.39738 9.88547C8.52286 9.88547 8.64831 9.83805 8.74414 9.7432L11.7475 6.77937C11.8413 6.68652 11.8947 6.56004 11.8947 6.42767C11.8947 6.29534 11.8418 6.16937 11.7475 6.076Z",
  fill: "currentColor"
});

function SvgLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    color: "#DB3E3E",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.ff035843.svg";
export { ForwardRef as ReactComponent };